import { Component  } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { ProfileLovComponent } from '../../profile/profile-lov/profile-lov.component';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';
import { Profile } from 'src/app/assabil-kernel/models/entities/master-data/profile-entity';
import { SecurityService } from 'src/app/security/services/security-service';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { LeanConfirmationComponent } from 'src/app/tools/components/lean-confirmation/lean-confirmation.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
    selector: 'person-list',
    templateUrl: './person-list.component.html',
    styleUrls: ['./person-list.component.scss']
})


export class PersonListComponent extends BasePage2<Person> {

   
    profileLovComponent = ProfileLovComponent;
     
    filterProfile    : Profile = new Profile();
    code    : string;
    name    : string;

    login       : string;
    password    : string;

    persons : Person[] = [];
    
    constructor(
        protected toastr            : ToastrService,
        protected masterDataService : MasterDataService,
        protected securityService   : SecurityService,
        protected router            : Router,
        protected baseService       : BaseService,
        protected leanUtilsService  : LeanUtilsService, 
        protected dialog            : MatDialog,
        protected location          : Location) {
         super(toastr, router, baseService, leanUtilsService, location);

         this.entityName = 'person';
    }



    //----------------------------------------------------------------------
        getRows(): Person[] {
            return this.persons;
        }
    //----------------------------------------------------------------------
     
     
    //----------------------------------------------------------------------
        new(){
            let person : Person = new Person();
            person.inserted   = true;
            person.edit       = true;
            this.persons.push(person);
            this.persons = [...this.persons];
        }
    //----------------------------------------------------------------------
     
    
    
    //----------------------------------------------------------------------
        saveRow(row: Person): Promise<Person> {
            return this.masterDataService.personSave(row);
        }
    //----------------------------------------------------------------------
    


    //----------------------------------------------------------------------
        loadData() {
            this.masterDataService.personsGet(this.code, this.name, this.filterProfile.profileCode).then(result => {
                this.persons = result;

                this.login = "";
                if (this.persons.length == 1) {
                    this.login = this.persons[0].login;
                }
                
            })
        }
    //----------------------------------------------------------------------



    //----------------------------------------------------------------------
    enrichField(field){
        if (field.prop == 'profile.name') {
            field.modal = ProfileLovComponent;
        }
    }
    //----------------------------------------------------------------------


    //----------------------------------------------------------------------
    resetPasswordButtonlabel : string = "Reinitialiser Mot de passe";  
    resetPassword() {

        if (  (! this.persons) || (this.persons.length == 0)) {
            this.showError("Prière de sélectionner la personne concernée par le reinitialisation de mot de passe !");
            return;
        }
        if  (this.persons.length > 1) {
            this.showError("Prière de sélectionner une seule personne à la fois pour le reinitialisation de mot de passe !");
            return;
        }

        let confirmationMessage = "Confimez-vous bien la reinitialisation de mot de passe pour la personne sélectionnée";

        let dialogRef = this.dialog.open(LeanConfirmationComponent, {autoFocus : false, hasBackdrop : false, data : {title : "Confirmation", confirmationMessage: confirmationMessage}} );
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.securityService.credentialsSet(this.persons[0].personCode, this.login, this.password).then(result => {
                    this.leanUtilsService.success();
                })
            }
        });
    }
    //----------------------------------------------------------------------
    
}

 